<template>
    <el-row type="flex" class="wx_error" justify="center">
      <el-col :span="12"><i class="el-icon-warning"></i><br />{{msg}}</el-col>
    </el-row>
</template>
<script>
    import {Col} from 'element-ui';
    export  default {
        data(){
            return{
                msg: '抱歉，只能在微信中打开',
            };
        },
      mounted () {
        this.$store.dispatch('hideHF');
      }
    }
</script>
<style slot-scope="scope">
    .wx_error {
        margin: 50px 0;
        text-align: center;
        line-height: 2;
    }
    .wx_error .el-icon-warning {
        color: #E5A32C;
        font-size: 2.75em;
    }
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxError.vue